import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '../components/Dashboard'
import Authorization from '../components/Authorization'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Dashboard',
      path: '/',
      component: Dashboard
    },
    {
      name: 'Authorization',
      path: '/authorization',
      component: Authorization
    },
    {
      name: 'Rest',
      path: '/*',
      redirect: '/'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js